import React from 'react';
import { Button } from '../ui/button';
import {
  Loader2, CheckCircle2, XCircle, FileText, Calendar, DollarSign,
  Download, Eye
} from 'lucide-react';

const ProfileBillingTab = ({
  receipts, loadingReceipts, setViewingReceipt, generateReceiptPDF, formatDate, formatCurrency,
}) => {
  return (
    <div className="space-y-4" data-testid="billing-section">
      <div className="bg-white rounded-2xl border border-stone-100 p-6">
        <div className="flex items-center justify-between mb-4">
          <h3 className="font-sans font-bold text-stone-800 text-sm flex items-center gap-2">
            <FileText className="w-4 h-4 text-stone-400" /> Payment history
          </h3>
        </div>
        {loadingReceipts ? (
          <div className="flex items-center justify-center py-12">
            <Loader2 className="w-6 h-6 animate-spin text-[#B49A88]" />
          </div>
        ) : receipts.length > 0 ? (
          <div className="divide-y divide-stone-50">
            {receipts.map((receipt) => (
              <div key={receipt.id || receipt.session_id} data-testid={`receipt-row-${receipt.id || receipt.session_id}`} className="flex flex-col sm:flex-row sm:items-center justify-between py-4 first:pt-0 last:pb-0 gap-3">
                <div className="flex items-center gap-3">
                  <div className={`w-9 h-9 rounded-lg flex items-center justify-center ${receipt.payment_status === 'paid' ? 'bg-green-50' : 'bg-amber-50'}`}>
                    {receipt.payment_status === 'paid' ? <CheckCircle2 className="w-4 h-4 text-green-500" /> : <XCircle className="w-4 h-4 text-amber-500" />}
                  </div>
                  <div>
                    <p className="font-sans font-medium text-stone-800 text-sm">
                      {receipt.metadata?.type === 'renewal' ? 'Subscription renewal' : receipt.subscription_tier === 'pro' ? 'Pro Plan' : 'Payment'}
                    </p>
                    <p className="font-sans text-stone-400 text-xs flex items-center gap-2">
                      <Calendar className="w-3 h-3" />
                      {receipt.created_at ? new Date(receipt.created_at).toLocaleDateString('en-US', { year: 'numeric', month: 'short', day: 'numeric' }) : '—'}
                      <span className={`text-[10px] font-semibold uppercase ${receipt.payment_status === 'paid' ? 'text-green-500' : 'text-amber-500'}`}>
                        {receipt.payment_status === 'paid' ? 'Paid' : receipt.payment_status}
                      </span>
                    </p>
                  </div>
                </div>
                <div className="flex items-center gap-3">
                  <p className="font-sans font-bold text-stone-800 text-sm">{formatCurrency(receipt.amount, receipt.currency)}</p>
                  <div className="flex items-center gap-1">
                    <button data-testid={`view-receipt-${receipt.id || receipt.session_id}`} onClick={() => setViewingReceipt(receipt)} className="p-1.5 rounded-lg hover:bg-stone-100 text-stone-400 hover:text-stone-600 transition-colors" title="Se kvittering"><Eye className="w-4 h-4" /></button>
                    <button data-testid={`download-receipt-${receipt.id || receipt.session_id}`} onClick={() => generateReceiptPDF(receipt)} className="p-1.5 rounded-lg hover:bg-stone-100 text-stone-400 hover:text-stone-600 transition-colors" title="Download PDF"><Download className="w-4 h-4" /></button>
                  </div>
                </div>
              </div>
            ))}
          </div>
        ) : (
          <div className="text-center py-12">
            <DollarSign className="w-8 h-8 text-stone-200 mx-auto mb-3" />
            <p className="font-sans text-stone-400 text-sm">No transactions yet</p>
            <p className="font-sans text-stone-300 text-xs mt-1">Your receipts will appear here after a purchase</p>
          </div>
        )}
      </div>
    </div>
  );
};

export { ProfileBillingTab };
